<template>
  	<div class="stores" @click='topHide' style="height:100%">
    	<div class="breadcrumb">智能模式跑 > 模式列表</div>
        <!-- 顶部按钮 -->
	    <div class="searchBtn" style="border:none;display:flex">
	      	<el-button size='small' type="success" @click="stage" plain v-has="'smart_mode_list_stage'" v-debounce>阶段</el-button>
	      	<el-button size='small' type="primary" @click="add" plain v-has="'smart_mode_list_add'" v-debounce>添加</el-button>
	      	<el-button size='small' type="warning" @click="edit" plain v-has="'smart_mode_list_update'" v-debounce>修改</el-button>
	      	<!-- <el-button size='small' type="info" @click="courseEncore" plain v-has="'smart_ode_list_reorganized'">重新编排</el-button> -->
	      	<el-button size='small' type="danger" @click="del" plain v-has="'smart_mode_list_delete'" v-debounce>删除</el-button>
	      	<!-- <el-date-picker
	      		v-model="timeVal"
	      		type="daterange"
	      		range-separator=" 至 "
	      		start-placeholder="模式开始日期"
	      		end-placeholder="模式结束日期"
      			value-format="yyyy-MM-dd">
	    	</el-date-picker> -->
	    	<!-- <el-button type="primary">搜索</el-button> -->
	    </div>
        <!-- 表格 -->
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" :data="tableData" highlight-current-row v-loading="loading" style="width: 100%"  @current-change="handleCurrentChange">
			        <el-table-column prop="id" label="ID" width="80%"></el-table-column>
			        <el-table-column prop="modeName" label="模式名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="modeIntensity"  label="模式难度" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div v-for="(item,id) in modeIntensityData" :key="id">
                                <span v-if="scope.row.modeIntensity == item.id">{{item.name}}</span>
                            </div>
                        </template>
                    </el-table-column>
			        <el-table-column prop="modeCalories"  label="预计消耗（大卡）" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.modeCalories / 1000}}
                        </template>
                    </el-table-column>
			        <el-table-column prop="memberPrivileges" label="会员专享" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.memberPrivileges == 0 ? '否' : '是'}}</template>
                    </el-table-column>
                    <el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间" show-overflow-tooltip></el-table-column>
		        </el-table>
	      	</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	    </div>
	    <!-- 添加修改弹框 -->
	    <el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
	      	<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="140px">
		        <el-form-item label="模式名称" prop="modeName">
		          	<el-input v-model="ruleForm.modeName" placeholder="请输入模式名字" style="width: 80%;" :disabled="is_director"></el-input>
		        </el-form-item>

               <input type="hidden" v-model="ruleForm.modeIntensity">
		        <el-form-item label="模式难度" prop="modeIntensity">
		          	<el-select v-model="ruleForm.modeIntensity" placeholder="请选择" style="width: 80%;" :disabled="is_director">
		            	<el-option v-for="(item,id) in modeIntensityData" :key="id" :label="item.name" :value="item.id">{{item.name}}</el-option>
		          	</el-select>
		        </el-form-item>

                <el-form-item label="预计消耗">
                    <el-input v-model="ruleForm.modeCalories" type="number" placeholder="请输入内容" style="width: 80%;">
                        <!-- <template slot="suffix">大卡</template> -->
                    </el-input>
                </el-form-item>
		        
	        	<el-form-item label="会员专享">
                    <el-radio-group v-model="ruleForm.memberPrivileges">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
				</el-form-item>

	        	<el-form-item label="模式介绍" prop="modeIntroduction">
	          		<el-input type="textarea" v-model="ruleForm.modeIntroduction" style="width:80%" :rows="4" :disabled="is_director"></el-input>
	        	</el-form-item>
		        
	      	</el-form>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSave()">确 定</el-button>	
	      	</span>
	    </el-dialog>
	    <!-- 阶段弹框 -->
	    <el-dialog title="模式阶段" :visible.sync="dialogVisible3" width="80%" :before-close="handleClose3" class='stagecon'>
	      	<div class="stagetit">
	        	<span>模式名称：{{ruleForm.modeName}}</span>
                <span v-for="(item,id) in modeIntensityData" :key="id" v-if="ruleForm.modeIntensity == item.id">
                    <!-- <span v-if="ruleForm.modeIntensity == item.id">模式难度：{{item.name}}</span> -->
                    模式难度：{{item.name}}
                </span>
		        <!-- <span>模式难度：{{ruleForm.modeIntensity}}</span> -->
		        <span>模式消耗(大卡)：{{ruleForm.modeCalories}}</span>
		        <span>会员专享：{{ruleForm.memberPrivileges == 0 ? '否' : '是'}}</span>
	      	</div>
	      	
	      	<el-table :data="modePhaseData" style="width: 100%" ref="multipleTable"  @current-change="handleCurrentChange2">
		        <el-table-column label="序号" align="center" prop="phase">
			        <template slot-scope="scope">
			            <label v-if="!scope.row.createTime">{{scope.row.phase}}</label>
			            <label v-else>{{scope.row.id}}</label>
			        </template>
		        </el-table-column>
		        <el-table-column prop="start" label="分钟">
		          	<template  slot-scope="{row,$index}">
                        <el-input v-if="!row.createTime" v-model="row.start" type="number"></el-input>
                        <el-input v-else-if="showEdit[$index]" v-model="editMOdePhaseData.start" type="number"></el-input>
                        <span v-else>{{row.start}}</span>
		        	</template>
		        </el-table-column>
		        <el-table-column prop="end" label="秒数">
		          	<template slot-scope="{row,$index}">
                        <el-input v-if="!row.createTime" v-model="row.end" type="number"></el-input>
                        <el-input v-else-if="showEdit[$index]" v-model="editMOdePhaseData.end" type="number"></el-input>
                        <span v-else>{{row.end}}</span>
		          	</template>
		        </el-table-column>
		        <el-table-column prop="motionStateData" label="运动状态">
			        <template slot-scope="{row,$index}">
                        <el-select v-if="!row.createTime" v-model="row.motionStateName" clearable placeholder="请选择运动状态">
                            <el-option  v-if="item.stateName !== '自定义'"
                            v-for="item in motionStateData"
                            :key="item.id"
                            :label="item.stateName"
                            :value="item.stateName">
                            </el-option>
                        </el-select>

                        <el-select v-else-if="showEdit[$index]" v-model="editMOdePhaseData.motionStateName" clearable placeholder="请选择运动状态">
                            <el-option  v-if="item.stateName !== '自定义'"
                            v-for="item in motionStateData"
                            :key="item.id"
                            :label="item.stateName"
                            :value="item.stateName">
                            </el-option>
                        </el-select>
                        <span v-else>{{row.motionStateName}}</span>
			        </template>
		        </el-table-column>
		        <el-table-column prop="stageSpeed" label="阶段速度">
		          	<template slot-scope="{row,$index}">
                        <el-input v-if="!row.createTime" v-model="row.stageSpeed" type="number"></el-input>
                        <el-input v-else-if="showEdit[$index]" v-model="editMOdePhaseData.stageSpeed" type="number"></el-input>
                        <span v-else>{{row.stageSpeed}}</span>
		          	</template>
		        </el-table-column>

                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="{row,$index}">
                        <el-row v-if="row.createTime">
                            <el-button type="text" size="small" v-if="!showEdit[$index]" @click="showUpdate($index,row)" v-debounce>修改</el-button>
                            <el-button type="text" size="small" v-if="showEdit[$index]" @click="submitUpdate($index,row)" v-debounce>确定</el-button>
                            <el-button type="text" size="small" v-if="showEdit[$index]" @click="cancelUpdate($index)" v-debounce>取消</el-button>
                        </el-row>
                        <el-row v-else>无</el-row>
                    </template>
                </el-table-column>
	      	</el-table>
			
			<div class="addBtn">
				<el-button type="primary" @click="addLine" plain>添加阶段</el-button>
	      		<el-button type="danger" @click="delLine" plain v-debounce>删除阶段</el-button>
			</div>

	      	<div style="padding:20px 0 0">总时长：{{global.formatSecond(stageTime)}}秒</div>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible3 = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit()">确 定</el-button>
	      	</span>
	    </el-dialog>

  	</div>
</template>  
<script>
export default {
    components: {},
    mounted() {
        //this.init()
        // 初始化表格
        this.page(this.pageNum, this.limit);
        // 获取模式难度列表
        this.selModeIntensity();
        if (eval(localStorage.getItem('userMenuButton')).indexOf('course_list_stick') != -1) {
            this.hasshow = true;
            return false;
        }
    },
    data() {
        return {
            loading: false,
            headers: {
                xqiao_token: localStorage.getItem('token')
            },
            tableData: [], //初始化表格
            modeIntensityData: {}, // 模式难度列表
            // 分页参数 start
            pageNum: 1,
            limit: 10,
            totalPage: 10,
            // 分页参数 end
            // 选中的ID
            currentRow: '',
            currentRowPhase: '', //选中的阶段ID
            ruleForm: {
                modeId: '',
                modeName: '', //模式名称
                modeIntensity: '', //模式难度ID
                modeCalories: '', //预计消耗(小卡)
                memberPrivileges: 0, //是否会员专享 0:非会员 1:会员
                modeIntroduction: '' //模式介绍
            },
            ruleForms: {
                modeName: [{ required: true, message: '请输入模式名称' }],
                modeCalories: [{ required: true, message: '请输入预计消耗' }],
                modeIntensity: [{ required: true, message: '请选择模式难度', trigger: 'change' }],
                modeIntroduction: [{ required: true, message: '请输入模式介绍' }]
            },
            motionStateData: [], // 运动状态列表
            motionStateName: '', //选中的运动状态
            dialogVisible: false,
            isAbbBtn: false,
            isShow: false,
            dialogVisible3: false,
            is_edit: true, //是否可编辑
            is_save: false, // 编辑后是否可保存
            //模式阶段列表
            modePhaseData: [],
            modeLength: '',// 存储原来的数据长度
            stageData: '', //阶段数据
            showEdit: [],
            fuzzyQueryShow: false,
            timeVal: '',
            dialogVisible4: false,
            is_director: false, //是否是导演角色
            hasshow: false,
            editMOdePhaseData: [], // 编辑模式阶段
        };
    },
    computed: {
        //计算时长
        stageTime: function() {
            let endTotal = 0;
            let that = this;
            for (let i = 0; i < that.modePhaseData.length; i++) {
                if (that.modePhaseData[i].end) {
                    endTotal += parseInt(that.modePhaseData[i].end);
                }
            }
            let startTotal = 0;
            for (let i = 0; i < that.modePhaseData.length; i++) {
                if (that.modePhaseData[i].start) {
                    startTotal += parseInt(that.modePhaseData[i].start);
                }
            }
            var stageTime2 = parseInt(startTotal * 60) + parseInt(endTotal);
            return stageTime2;
            // return that.global.formatSecond(stageTime2);
        }
    },
    filters: {
        formatDate: function(value) {
            let date = new Date(value);
            let h = date.getHours();
            h = h < 10 ? '0' + h : h;
            let m = date.getMinutes();
            m = m < 10 ? '0' + m : m;
            let s = date.getSeconds();
            s = s < 10 ? '0' + s : s;
            return h + '时' + m + '分' + s;
        }
    },
    methods: {
        //初始化表格数据
        page(pageNum, limit) {
            var params = this.calculate();
            this.loading = true;
            this.$get('/presetMode/getPresetModeList', params)
                .then(res => {
                    this.loading = false;
                    if (res.code == 0) {
                        this.tableData = res.data.list;
                        this.totalPage = res.data.total;
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                    console.log();
                });
            return false;
        },
        calculate() {
            var dataFer = {
                limit: this.limit,
                pageNum: this.pageNum
            };
            if (this.timeVal) {
                dataFer.beginTime = this.$moment(this.timeVal[0]).valueOf();
                dataFer.endTime = this.$moment(this.timeVal[1]).valueOf();
            }
            return dataFer;
        },
        init() {
            var params = {
                limit: this.limit,
                pageNum: this.pageNum
            };
            this.$get('/presetMode/getPresetModeList', params).then(res => {
                this.loading = false;
                if (res.code == 0) {
                    this.tableData = res.data.list;
                    this.totalPage = res.data.total;
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                    return false;
                }
            });
        },
        topHide() {
            this.fuzzyQueryShow = false;
        },
        //选择需要修改的权限
        handleCurrentChange(val) {
            console.log(val);
            if (val) {
                this.currentRow = val.id;
            }
        },
        // 选择需要删除的阶段
        handleCurrentChange2(val){
            // console.log(val)
            if (val) {
                this.currentRowPhase = val.phase;
            }
        },
        //当前页数
        handleCurrentChangePage(val) {
            this.pageNum = val;
            this.currentRow = '';
            this.page(this.pageNum, this.limit);
            //this.init();
        },
        //弹框关闭按钮
        handleClose(done) {
            if (this.$refs.ruleForm != undefined) {
                this.$refs.ruleForm.resetFields();
                this.$refs.ruleForm.clearValidate();
                this.ruleForm = {
                    modeId: '',
                    modeName: '', //模式名称
                    modeIntensity: '', //模式难度ID
                    modeCalories: '', //预计消耗(小卡)
                    memberPrivileges: 0, //是否会员专享 0:非会员 1:会员
                    modeIntroduction: '' //模式介绍
                };
            }
            done();
        },
        //
        handleClose3() {
            this.dialogVisible3 = false;
        },
        //添加按钮
        add(row) {
            // this.$refs.multipleTable.setCurrentRow(row);
            this.ruleForm = {
                modeId: '',
                modeName: '', //模式名称
                modeIntensity: '', //模式难度ID
                modeCalories: '', //预计消耗(小卡)
                memberPrivileges: 0, //是否会员专享 0:非会员 1:会员
                modeIntroduction: '' //模式介绍
            };
            this.dialogVisible = true;
            this.isAbbBtn = true;
            // this.currentRow = '';
            // this.init();
            this.selModeIntensity(); //模式难度
            if (this.$refs.ruleForm != undefined) {
                this.$refs.ruleForm.resetFields();
            } 
        },
        // 编辑按钮
        edit() {
            if (this.currentRow) {
                this.dialogVisible = true;
                this.isAbbBtn = false;
                this.getModeDetail();
            } else {
                this.dialogVisible = false;
                this.$message({
                    message: '请选择信息',
                    type: 'warning'
                });
                return false;
            }
        },
        // 删除按钮
        del() {
            var that = this;
            var currentRowId = that.currentRow;
            if (currentRowId) {
                that
                    .$confirm('确定要删除吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        that.loading = true;
                        that.$axios
                            .post('/presetMode/del', { modeId: currentRowId })
                            .then(function(res) {
                                that.loading = false;
                                console.log(res);
                                if (res.data.code == 0) {
                                    console.log(' 删除成功 ');
                                    that.$message({
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    that.pageNum = 1;
                                    that.currentRow = '';
                                    that.init();
                                    that.dialogVisible = false;
                                } else {
                                    that.errorMsg('操作失败');
                                }
                            })
                            .catch(function(err) {
                                console.log(err);
                            });
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            } else {
                this.$message({
                    message: '请选择信息',
                    type: 'warning'
                });
                return false;
            }
        },
        // 编辑／添加　保存
        onSave() {
            // 这里需要判断是添加还是编辑，不能只通过this.currentRow判断
            this.dialogVisible = true;
            this.ruleForm.modeCalories = this.ruleForm.modeCalories * 1000;
            //通过表单id判断，如果id有值且isAddBtn为false为修改，否则是添加
            if (this.currentRow && !this.isAbbBtn) {
                console.log('修改');
                var updateForm = {
                    modeId: this.ruleForm.id,
                    modeName: this.ruleForm.modeName, //模式名称
                    modeIntensity: this.ruleForm.modeIntensity, //模式难度ID
                    modeCalories: this.ruleForm.modeCalories,
                    memberPrivileges: this.ruleForm.memberPrivileges, //是否会员专享 0:非会员 1:会员
                    modeIntroduction: this.ruleForm.modeIntroduction //模式介绍
                };
                console.log(updateForm);
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$axios
                            .post('/presetMode/upd', JSON.stringify(updateForm))
                            .then(res => {
                                this.loading = false;
                                if (res.data.code == 0) {
                                    this.$message({
                                        message: '修改成功',
                                        type: 'success'
                                    });
                                    this.$refs.ruleForm.resetFields();
                                    this.$refs.ruleForm.clearValidate();
                                    this.dialogVisible = false;
                                    this.page(this.pageNum, this.limit);
                                } else {
                                    this.$message({
                                        message: res.data.message,
                                        type: 'warning'
                                    });
                                    return false;
                                }
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            } else {
                console.log('添加');
                this.isAbbBtn = false;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$post('/presetMode/add', JSON.stringify(this.ruleForm))
                            .then(res => {
                                this.loading = false;
                                if (res.code == 0) {
                                    this.$message({
                                        message: '添加成功',
                                        type: 'success'
                                    });
                                    this.$refs.ruleForm.resetFields();
                                    this.dialogVisible = false;
                                    this.common();
                                } else {
                                    this.$message({
                                        message: res.message,
                                        type: 'warning'
                                    });
                                    return false;
                                }
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
        // 选择模式难度
        selModeIntensity(e) {
            this.$get('/presetMode/getPresetModeIntensity')
                .then(res => {
                    console.log('模式难度');
                    console.log(res);
                    this.loading = false;
                    if (res.code == 0) {
                        this.modeIntensityData = res.data;
                        console.log(this.modeIntensityData);
                        cosnole.log(e);
                        if (e == 'change') {
                            this.ruleForm.courseKindName = res.data[0].name;
                            this.ruleForm.kindId = res.data[0].id;
                        }
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                        return false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                    console.log();
                });
        },
        //点击阶段
        stage() {
            if (this.currentRow) {
                this.dialogVisible3 = true;
                this.getModeDetail(); // 获取模式详情
                this.getMotionState(); // 获取运动状态
            } else {
                this.dialogVisible3 = false;
                this.$message({
                    message: '请选择信息',
                    type: 'warning'
                });
                return false;
            }
        },
        // 获取模式详情
        getModeDetail() {
            this.loading = true;
            this.$get('/presetMode/getPresetModeDetail', { modeId: this.currentRow })
            .then(res => {
                this.loading = false;
                if (res.code == 0) {
                    this.$nextTick(function() {
                        res.data.modeCalories = res.data.modeCalories / 1000;
                        this.ruleForm = res.data;
                            res.data.stageList.map(item => {
                            item.start = parseInt(item.stageTime / 60);
                            item.end = parseInt(item.stageTime) % 60;
                            item.phase = item.stage;
                        });
                        this.modePhaseData = res.data.stageList;
                        this.modeLength = this.modePhaseData.length;
                    });
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                }
            })
            .catch(() => {
                this.loading = false;
            });
        },
        // 获取运动状态
        getMotionState() {
            this.loading = true;
            this.$get('/presetMode/getPresetModeMotionState')
                .then(res => {
                    this.loading = false;
                    if (res.code == 0) {
                        this.$nextTick(function() {
                            this.motionStateData = res.data;
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //添加阶段
        addLine() {
            this.newValue = {
                start: '',
                end: '',
                motionStateName: '', // 运动状态名称
                presetModeId: this.currentRow, // 预设模式ID
                stageSpeed: '', // 阶段速度
                stageTime: '', // 阶段时间
                phase: this.modePhaseData.length + 1 // 阶段
            };
            //添加新的行数
            this.modePhaseData.push(this.newValue);
        },
        //删除阶段
        delLine(){
            let flag = this.modePhaseData.some( item => {
                if(item.createTime){
                    return false;
                } else {
                    return true;
                }
            })
            if(flag){
                this.modePhaseData.pop();
            } else {
                this.$message({
                    message: '已经添加的数据只能修改，无法删除！',
                    type: 'warning'
                });
            }
        },
        // 阶段提交
        onSubmit() {
            var istrue = false, data = [];
            this.modePhaseData.map(item => {
                for (var k in item) {
                    if (item[k] === '') {
                        this.$message.error('input不能为空');
                        istrue = false;
                        return false;
                    } else {
                        if(item.start && item.end){
                            item.stageTime = parseInt(item.start) * 60 + parseInt(item.end);
                            item.stage = item.phase;
                        }
                        istrue = true;
                    }
                }
                var result = {
                    motionStateName: item.motionStateName,
                    presetModeId: item.presetModeId,
                    stage: item.stage,
                    stageSpeed: item.stageSpeed,
                    stageTime: item.stageTime,
                }
                data.push(result);
            });
            if (istrue == true) {
                this.$post('/presetMode/addStage',JSON.stringify(data.slice(this.modeLength)))
                    .then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            //this.init();
                            this.modePhaseData = [];
                            this.getModeDetail();
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'warning'
                            });
                            return false;
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        console.log();
                    });
            } else if(this.modePhaseData.length == 0){
                this.$message({
                    message: '请至少添加一个阶段！',
                    type: 'warning'
                });
            }
        },
        // 编辑阶段按钮
        showUpdate(index,row){
            this.editMOdePhaseData = {
                start: row.start,
                end: row.end,
                motionStateName: row.motionStateName, // 运动状态名称
                presetModeId: row.id, // 预设模式ID
                stageSpeed: row.stageSpeed, // 阶段速度
                stageTime: row.stageTime, // 阶段时间
            };
            this.showEdit[index] = true;
            this.$set(this.showEdit,index,true)   //这里要用$set方法，否则页面状态不更新
       },
        //编辑阶段后保存
        submitUpdate(index, row) {
            this.loading = true;
            this.$set(this.showEdit,index,false);
            this.editMOdePhaseData.presetModeId = row.presetModeId;
            this.editMOdePhaseData.stageTime = parseInt(this.editMOdePhaseData.start) * 60 + parseInt(this.editMOdePhaseData.end);
            this.$set(this.modePhaseData, index, this.editMOdePhaseData);
            //发送请求，隐藏输入框
            this.$post('/presetMode/updStage', {
                modeId: row.presetModeId,
                presetModeStages: this.modePhaseData
            }).then(data=>{
                this.loading = false;
                if (data.code === 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        onClose: () => {
                            this.$set(this.showEdit,index,false)
                        }
                    })
                    this.getModeDetail();
                } else {
                    this.loading = false;
                    this.$message.error(data.code)
                }
            })
        },
        // 取消修改
        cancelUpdate(index){
            this.$confirm('确定要取消修改吗？','提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.$set(this.showEdit,index,false) 
            }).catch(() => {})
        },
        common() {
            this.currentRow = '';
            this.pageNum = 1;
            this.timeVal = '';
            this.sportsKindId = 0;
            this.page(this.pageNum, this.limit);
        }
    }
};
</script>

<style scoped>
.main {
    margin: 10px auto;
    box-shadow: 0 0 8px 0 rgb(232 237 250 / 60%), 0 2px 4px 0 rgb(232 237 250 / 50%);
}
::deep .avatar-uploader-icon {
    width: 108px;
    line-height: 108px;
}
.selectUser {
    color: #409eff;
}
.selectUser label,
.selectUser i {
    font-size: 12px;
}

::deep .stagecon .el-dialog__body {
    padding: 10px 20px;
}
::deep .el-date-editor .el-range-separator {
    padding: 0;
}
.searchBtn .el-range-editor.el-input__inner {
    margin: 0 15px;
}
.topinput {
    position: relative;
    margin: 0 15px;
    width: 250px;
}
.topinput input {
    font-size: 13px;
}
.nickNameul {
    position: absolute;
    z-index: 10;
    background: #fff;
    width: 100%;
    padding: 10px;
    font-size: 13px;
    line-height: 25px;
    border: 1px solid #dcdfe6;
    border-top: none;
}
.nickNameul li {
    color: #666;
    cursor: pointer;
}
.nickNameul li:hover {
    color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/smartModeList/index.vue